"use client";
import React from "react";
import { Box } from "@dxp-feed/ui/Box";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";
import FooterMenu from "./FooterMenu";
import Social from "./Social";


export default function Footer({ footerData }: any) {
  const pathname = usePathname();
  const NoHeaderPage = ["/maintenance"];

  return (
    <>
      {!NoHeaderPage.includes(pathname) && (
        <Box as="div" className="bg-brandWhite mt-auto min-h-[300px]">
          <Social footerData={footerData} />
          <FooterMenu footerData={footerData} />
        </Box>
      )}
    </>
  );
}
